export const API_ROOT_TEST = 'https://istyle-backend-test.bis-pro.com/b1s/v2/'
export const CUSTOM_API_ROOT_TEST =
  'https://istyle-backend-test.bis-pro.com/api/'

export const API_ROOT_PROD = 'https://probox-new-back-prod-v2.bis-apps.com/b1s/v2/'
export const CUSTOM_API_ROOT_PROD =
  'https://probox-new-back-prod-v2.bis-apps.com/api/'
